import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_VIEW_CATEGORIES')